export default __webpack_public_path__ + "static/media/480_dummy2016-physiotherapie01-de.85ea9681.png";